import { Alert, Skeleton, Table, Tag } from "antd";
import type { ColumnsType } from "antd/es/table";
import { useTranslation } from "react-i18next";
import { useEmployeeZoneAssignments } from "../hooks/useEmployeeProfile";
import type { EmployeeZoneAssignment } from "../services/employeeZones.api";

/**
 * «Hududlar» yorlig'i — xodimning hudud biriktirishlari TARIXI.
 *
 * ⚠️⚠️ **`usePaginatedQuery`/`DataTable` ISHLATILMAYDI.** Javob
 * SAHIFALANMAGAN massiv (`createSuccessSchema(z.array(...))`,
 * `employee-zones.schemas.ts`), `DataTable` esa `PaginatedQueryResult`
 * kutadi — u yerga oddiy massiv berish `meta` ni `undefined` qoldirib
 * jadvalni buzardi.
 *
 * ⚠️⚠️ **Yakunlangan biriktirish O'CHIRILMAYDI, so'lg'in chiziladi.**
 * `employee_zones` — APPEND-ONLY (CLAUDE.md): o'tgan oy davomati o'sha
 * davrda AMALDA bo'lgan biriktirish bo'yicha hisoblanadi, ya'ni tarix
 * hisobning bir qismi. Uni yashirish foydalanuvchiga «bu hudud hech
 * qachon biriktirilmagan» degan yolg'on taassurot berardi.
 *
 * ⚠️ Holat SERVERNING `amalda` maydonidan, `validTo === null` dan EMAS:
 * muddatli biriktirishda `validTo` KELAJAKDA bo'lishi mumkin va u hali
 * amalda.
 */
export function EmployeeZonesTab({ employeeId }: { employeeId: string }) {
	const { t } = useTranslation("employees");
	const { data = [], isLoading, isError } = useEmployeeZoneAssignments(employeeId);

	const columns: ColumnsType<EmployeeZoneAssignment> = [
		{ title: t("zonesTab.columns.zone"), dataIndex: "zoneName", key: "zoneName" },
		{ title: t("zonesTab.columns.type"), dataIndex: "tur", key: "tur" },
		{ title: t("zonesTab.columns.validFrom"), dataIndex: "validFrom", key: "validFrom" },
		{
			title: t("zonesTab.columns.validTo"),
			key: "validTo",
			render: (_, row) => row.validTo ?? "—",
		},
		{
			title: t("zonesTab.columns.status"),
			key: "amalda",
			render: (_, row) =>
				row.amalda ? (
					<Tag color="blue">{t("zonesTab.statusActive")}</Tag>
				) : (
					<Tag>{t("zonesTab.statusEnded")}</Tag>
				),
		},
	];

	if (isError) {
		return <Alert type="error" showIcon message={t("zonesTab.loadError")} />;
	}

	if (isLoading) {
		return <Skeleton active />;
	}

	return (
		<>
			<Table<EmployeeZoneAssignment>
				rowKey="id"
				size="small"
				pagination={false}
				dataSource={data}
				columns={columns}
				rowClassName={(row) => (row.amalda ? "" : "opacity-60")}
			/>

			<div className="mt-3 text-xs text-[#8a929e]">{t("zonesTab.historyNote")}</div>
		</>
	);
}
